import { render, staticRenderFns } from "./rich_viewer.vue?vue&type=template&id=5fc47aa8"
import script from "./rich_viewer.vue?vue&type=script&lang=js"
export * from "./rich_viewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports